<div class="success-stories" *ngIf="successStories.length">
  <div class="container">
    <div class="top-heading text-center">
      <h2>Success Stories</h2>
    </div>
    <div class="card-wrapper">
      <ngx-glide [showArrows]="true" [showBullets]="false" [breakpoints]="breakpoints" [perView]="1" [bound]="true" [gap]="15" arrowLeftLabel="" arrowRightLabel="">
        <div class="succes-stories-box" *ngFor="let story of successStories" >
          <div class="story-image">
            <img loading="lazy" [attr.data-src]="getBannerImage(story)" class="" [alt]="story?.title"/>
          </div>
          <div class="story-content-wrapper">
            <div class="story-content">
              <h2>{{story?.title}}</h2>
              <p class="content">{{story?.descr}}</p>
              <div class="read-more"><a [href]="story.action">Read more</a></div>
              <div class="whatsapp-cta">
                <p>Subscribe to read such inspiring stories <a [href]="'https://api.whatsapp.com/send?phone=91' + variablesService.contactUsMobNumber+ '&text=Count%20me%20in%21%20I%20want%20to%20subscribe%20to%20Ketto%20Voice.'" class="whatsapp-btn" target="_blank"><span class="icon-whatsapp"></span>Subscribe</a></p>
              </div>
            </div>
          </div>
        </div>
      </ngx-glide>
    </div>
  </div>
</div>
